export default __webpack_public_path__ + "static/media/image10.05065aa1.jpg";